// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_IFPHZ {
  padding: 16px;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
}

.plyLayerContent_oszIw {
  padding: 12px;
}

.plyLayer_LoV8c {
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid var(--color-base300);
  border-radius: 6px;
  background-color: white;
  min-height: 48px;
}

.plyLayer_LoV8c:last-child {
  margin-bottom: 0;
}

.statusPill_GcwzE {
  flex-grow: 1;
  justify-content: center;
  overflow: hidden;
  font-size: 14px;
  padding: 6px 12px;
  min-height: 25px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.pillsContainer_jiJFD {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.plyLayerGroup_miloI {
  border: 1px solid var(--color-base300);
  border-radius: 8px;
  margin-bottom: 16px;
  background-color: var(--color-base050) !important;;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.groupHeader_NmRNB {
  padding: 12px 16px;
  background-color: var(--color-base050);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-base300);
}

.groupContent_lZ4q7 {
  padding: 12px;
}

.laserLayerTitle_Kcie5 {
  font-size: 18px;
  font-weight: 600;
  margin: 16px 0 8px 8px;
}

.layerGroupsContainer_kIBhM {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  margin-bottom: 16px;
}

.plyLayerGrid_bvoKQ {
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;
  gap: 16px;
}

.dialogBody_UhARl{
  gap: 4px;
  padding: 16px;
  background: #f3f5f6;
  box-shadow: 0px 1px 3px rgba(41, 50, 61, 0.16);
  border-bottom: 1px solid #f3f5f6;
  border-top: 1px solid #f3f5f6;
  width: 100%;
  overflow: hidden;
}

.imageContainer_AMAVE {
  width: 100%;
  max-width: 300px;
  border: 1px solid var(--color-base300);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.image_TVHZ0 {
  width: 100%;
  height: auto;
  display: block;
}

.radioGroup_izHtz {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radioLabel_oTlPg {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--color-base900);
  cursor: pointer;
}

.radioInput_J77ec {
  margin: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.cameraDialog_G_BWQ {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.cameraDialog .ui-dialog {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  max-width: none !important;
  background: none !important;
  border: none !important;
  display: grid !important;
  grid-template-rows: auto 1fr !important;
  overflow: hidden !important;
}

.cameraDialog .ui-dialog-content {
  display: grid !important;
  place-items: center !important;
  padding: 0 !important;
  overflow: hidden !important;
  aspect-ratio: 3/4 !important;
  max-height: calc(100vh - 78px) !important; /* Subtract header height */
  max-width: min(90vh, 100vw) !important; /* Keep proportional */
  margin: 0 auto !important;
}

@media screen and (max-width: 768px) {
  .ui-dialog,
  .ui-dialog-content,
  .dialogContent_M_CiW {
    overflow-x: hidden !important;
    width: 90vw !important;
    max-width: 90vw !important;
    margin: 0 auto !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    border-radius: 8px !important; 
  }

  .ui-dialog-footer {
    padding: 12px !important;
    display: flex !important;
    gap: 8px !important;
  }

  .ui-dialog-footer button {
    flex: 1 !important;
    min-width: 0 !important;
    padding: 8px !important;
    font-size: 14px !important;
    white-space: nowrap !important;
  }

  .cameraDialog .ui-dialog {
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    transform: none !important;
    left: 0 !important;
    top: 0 !important;
    border-radius: 0 !important;
    padding-bottom: env(safe-area-inset-bottom, 20px) !important;
  }
  
  .cameraDialog .ui-dialog-content {
    width: 100% !important;
    height: auto !important;
    max-width: 100vw !important;
    max-height: calc(100dvh - 150px) !important;
    aspect-ratio: auto !important;
    padding-bottom: 60px !important;
  }

  .dialogBody_UhARl {
    padding: 12px;
    max-width: 90vw;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  .takePhotoButton_vlBiv {
    width: 100%;
    margin: 8px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/plyLayer/PlyLayerShopFloor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,gCAAgC;EAChC,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,yCAAyC,EAAE,2BAA2B;EACtE,sCAAsC,EAAE,sBAAsB;EAC9D,yBAAyB;AAC3B;;AAEA;EACE;;;IAGE,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,oBAAoB;IACpB,sCAAsC;IACtC,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,4DAA4D;EAC9D;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,2CAA2C;IAC3C,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".container {\n  padding: 16px;\n  gap: 16px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.plyLayerContent {\n  padding: 12px;\n}\n\n.plyLayer {\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid var(--color-base300);\n  border-radius: 6px;\n  background-color: white;\n  min-height: 48px;\n}\n\n.plyLayer:last-child {\n  margin-bottom: 0;\n}\n\n.statusPill {\n  flex-grow: 1;\n  justify-content: center;\n  overflow: hidden;\n  font-size: 14px;\n  padding: 6px 12px;\n  min-height: 25px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.pillsContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.plyLayerGroup {\n  border: 1px solid var(--color-base300);\n  border-radius: 8px;\n  margin-bottom: 16px;\n  background-color: var(--color-base050) !important;;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.groupHeader {\n  padding: 12px 16px;\n  background-color: var(--color-base050);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--color-base300);\n}\n\n.groupContent {\n  padding: 12px;\n}\n\n.laserLayerTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 16px 0 8px 8px;\n}\n\n.layerGroupsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0;\n  margin-bottom: 16px;\n}\n\n.plyLayerGrid {\n  display: grid;\n  grid-template-columns: 1fr 4fr;\n  align-items: center;\n  gap: 16px;\n}\n\n.dialogBody{\n  gap: 4px;\n  padding: 16px;\n  background: #f3f5f6;\n  box-shadow: 0px 1px 3px rgba(41, 50, 61, 0.16);\n  border-bottom: 1px solid #f3f5f6;\n  border-top: 1px solid #f3f5f6;\n  width: 100%;\n  overflow: hidden;\n}\n\n.imageContainer {\n  width: 100%;\n  max-width: 300px;\n  border: 1px solid var(--color-base300);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.image {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--color-base900);\n  cursor: pointer;\n}\n\n.radioInput {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.cameraDialog {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n}\n\n:global(.cameraDialog .ui-dialog) {\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  max-width: none !important;\n  background: none !important;\n  border: none !important;\n  display: grid !important;\n  grid-template-rows: auto 1fr !important;\n  overflow: hidden !important;\n}\n\n:global(.cameraDialog .ui-dialog-content) {\n  display: grid !important;\n  place-items: center !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  aspect-ratio: 3/4 !important;\n  max-height: calc(100vh - 78px) !important; /* Subtract header height */\n  max-width: min(90vh, 100vw) !important; /* Keep proportional */\n  margin: 0 auto !important;\n}\n\n@media screen and (max-width: 768px) {\n  :global(.ui-dialog),\n  :global(.ui-dialog-content),\n  :global(.dialogContent_M_CiW) {\n    overflow-x: hidden !important;\n    width: 90vw !important;\n    max-width: 90vw !important;\n    margin: 0 auto !important;\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n    border-radius: 8px !important; \n  }\n\n  :global(.ui-dialog-footer) {\n    padding: 12px !important;\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  :global(.ui-dialog-footer button) {\n    flex: 1 !important;\n    min-width: 0 !important;\n    padding: 8px !important;\n    font-size: 14px !important;\n    white-space: nowrap !important;\n  }\n\n  :global(.cameraDialog .ui-dialog) {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh !important;\n    transform: none !important;\n    left: 0 !important;\n    top: 0 !important;\n    border-radius: 0 !important;\n    padding-bottom: env(safe-area-inset-bottom, 20px) !important;\n  }\n  \n  :global(.cameraDialog .ui-dialog-content) {\n    width: 100% !important;\n    height: auto !important;\n    max-width: 100vw !important;\n    max-height: calc(100dvh - 150px) !important;\n    aspect-ratio: auto !important;\n    padding-bottom: 60px !important;\n  }\n\n  .dialogBody {\n    padding: 12px;\n    max-width: 90vw;\n    overflow: hidden;\n    box-sizing: border-box;\n  }\n  \n  .takePhotoButton {\n    width: 100%;\n    margin: 8px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_IFPHZ`,
	"plyLayerContent": `plyLayerContent_oszIw`,
	"plyLayer": `plyLayer_LoV8c`,
	"statusPill": `statusPill_GcwzE`,
	"pillsContainer": `pillsContainer_jiJFD`,
	"plyLayerGroup": `plyLayerGroup_miloI`,
	"groupHeader": `groupHeader_NmRNB`,
	"groupContent": `groupContent_lZ4q7`,
	"laserLayerTitle": `laserLayerTitle_Kcie5`,
	"layerGroupsContainer": `layerGroupsContainer_kIBhM`,
	"plyLayerGrid": `plyLayerGrid_bvoKQ`,
	"dialogBody": `dialogBody_UhARl`,
	"imageContainer": `imageContainer_AMAVE`,
	"image": `image_TVHZ0`,
	"radioGroup": `radioGroup_izHtz`,
	"radioLabel": `radioLabel_oTlPg`,
	"radioInput": `radioInput_J77ec`,
	"cameraDialog": `cameraDialog_G_BWQ`,
	"takePhotoButton": `takePhotoButton_vlBiv`
};
export default ___CSS_LOADER_EXPORT___;
